import Component from "../component.abstract";
import { getInstanceByElementName } from "../../core"
import Selector from "../multiselect/select"

interface FacetsEngineProps {
    value:string
}
/*
    FacetsEngine will deal with mobile tunnel interaction (i.e. hide/show input) and auto submit engine form when both input are filled and we are not in serp context
*/

export default class FacetsEngine extends Component {
    public url:string
    public inputs:NodeListOf<Element>
    private onboarding = document.getElementById("engineonboarding") as HTMLInputElement;
    private enginewhat = document.getElementById("enginewhat") as HTMLInputElement;
    private enginewhere = document.getElementById("enginewhere") as HTMLInputElement;
    private enginecontracts = document.getElementById("enginecontracts") as HTMLInputElement;
    private enginec = document.querySelector("[name=enginec");
    private alertJobField = document.querySelector("[data-alert-job-field]");
    private alertCityField = document.querySelector("[data-alert-city-field]");

    constructor (
        private props: FacetsEngineProps,
        element:HTMLElement
    ) {
        super(props, element)
        this.url = this.props.value
        this.inputs = this.element.querySelectorAll('input[type="text"]');
    }

    mounted(): void {
        if(this.onboarding) {
           this.onboarding.addEventListener("change",(event) => {
                if((<HTMLInputElement>event.currentTarget).checked) {
                    (<HTMLElement>event.currentTarget).parentElement.classList.add('opened')
                } else {
                     (<HTMLElement>event.currentTarget).parentElement.classList.remove('opened')
                }
           })
       }
       this.inputs.forEach((input:Element) => {
           input.addEventListener("blur",() => {
               if((<HTMLInputElement>document.querySelectorAll('[name=k]')[0]).value != "" && (<HTMLInputElement>document.querySelectorAll('[name=l]')[0]).value != "") {
                        if (window.innerWidth < 767) {
                             setTimeout(() => {
                               this.showFunnel();
                             }, 300);
                        }

                        if(!document.getElementById('facets') && document.querySelectorAll(".noresult").length === 0) {
                            setTimeout(() => {
                                (<HTMLFormElement>document.getElementById('engine')).submit();
                            },300)
                        }   
                }
                
           })
           input.addEventListener("change",() => {
                if((<HTMLInputElement>document.querySelectorAll('[name=k]')[0]).value != "" && (<HTMLInputElement>document.querySelectorAll('[name=l]')[0]).value != "") {
                        if(!document.getElementById('facets') && document.querySelectorAll(".noresult").length === 0) {
                            setTimeout(() => {
                                (<HTMLFormElement>document.getElementById('engine')).submit();
                            },400)
                        }   
                }
                PubSub.publish("engine-mobile.changed")
           })

           if(!this.alertCityField && !this.alertJobField)
           PubSub.subscribe("autocomplete-change",()=>{
                if((<HTMLInputElement>document.querySelectorAll('[name=l]')[0]).value === "") {
                    (<HTMLInputElement>document.querySelector('.autocomplete-innerinput-l')).focus()
                }
                if((<HTMLInputElement>document.querySelectorAll('[name=k]')[0]).value === "") {
                    (<HTMLInputElement>document.querySelector('.autocomplete-innerinput-k')).focus()
                }
           })

           input.addEventListener("focus",() => {
                if(input.tagName === "k") {
                    setTimeout(() => {
                        this.inputWhat()   
                    }, 50);         
                } else {
                    setTimeout(() => {
                        this.inputWhere()
                    }, 50);
                }
           })
       })
       if(this.enginec) {
            this.enginec.addEventListener("change",() => {
                    if(document.querySelectorAll('[data-facets].side').length == 0) {
                        const instanceEnginec:Selector = getInstanceByElementName("Selector","enginec");
                        const options = instanceEnginec.getSelectedOptions();
                        for(const option of options) {
                            const input = document.createElement('input');
                            input.setAttribute('type', 'hidden');
                            input.setAttribute('name','c')
                            const form = document.getElementById('engine');
                            form.appendChild(input);
                            input.value = option;
                        }
                    }
            })
       }
      
    }
    quitField():void {
       setTimeout(() => {
           this.showFunnel()
           if(window.innerWidth < 767) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
       }, 50);
    }
    inputWhat():void {
        this.showWhat()
        this.hideWhere()
        this.hideContracts();
    }
    inputWhere():void {
        this.showWhat()
        this.showWhere()
        this.hideContracts();
    }
    inputContracts():void {
        this.hideWhat()
        this.hideWhere()
        this.hideContracts();
    }
    showWhat():void {
        if(this.enginewhat) this.enginewhat.checked = true;
    }
    hideWhat():void {
        if(this.enginewhat) this.enginewhat.checked = false;
    }
    showWhere():void {
        if(this.enginewhere) this.enginewhere.checked = true;
    }
    hideWhere():void {
        if(this.enginewhere) this.enginewhere.checked = false;
    }
    showContracts():void {
        if(this.enginecontracts) this.enginecontracts.checked = true;
    }
    hideContracts():void {
        if(this.enginecontracts) this.enginecontracts.checked = false;
    }
    showFunnel():void {
        this.showWhat()
        this.showWhere()
        this.showContracts()
    }
}